import { FIREFLY_DOUBLE_CLICK_MS } from "@/lib/firefly/fireflyPttConstants";

export type FireflyTabRelease = "toggle" | "defer" | "double_click_ptt";

/**
 * Desktop single-click waits one double-click window before opening the
 * panel. A second release inside that window starts push-to-talk instead,
 * so the opening panel cannot receive the second click.
 */
export function classifyFireflyTabRelease(input: {
  pointerType: string;
  nowMs: number;
  previousTapMs: number | null;
  armsDoubleClickPtt: boolean;
}): FireflyTabRelease {
  const desktop = input.pointerType === "mouse" || input.pointerType === "pen";
  if (!input.armsDoubleClickPtt || !desktop) return "toggle";
  if (
    input.previousTapMs != null &&
    input.nowMs >= input.previousTapMs &&
    input.nowMs - input.previousTapMs < FIREFLY_DOUBLE_CLICK_MS
  ) {
    return "double_click_ptt";
  }
  return "defer";
}
